



























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Getter,Action } from "vuex-class";
import store from "@/store";
import getUrlParam from "@/common/utils/getUrlParam";

@Component
export default class UserAgreementModal extends Vue {
  @Prop()
  show!: boolean;
  @Prop()
  type!: string;
  @Getter("showFooter") showFooter!: boolean;
  @Getter("openUser") openUser!: boolean;
  @Action("changeShowFooter") changeShowFooter!: Function;

  get sectionConf() {
    return store.getters.section;
  }

  get distributeTypeParameter() {
    return store.getters.distributeTypeParameter;
  }

  handleOk() {
    this.$emit("ok");
  }
  handleCancel() {
    this.$emit("cancel");
  }

  toggleCheckUserAgreement(isCheck: boolean) {
    store.dispatch("changeDistributeParameter", {
      hasCheckUserAgreement: isCheck,
    });
  }

  handleViewUserAgreement(isOpen: boolean) {
    store.dispatch("changeDistributeParameter", {
      isUserAgreementVisible: isOpen,
    });
    if(isOpen){
      // 用 openUser 控制用户协议的展示与否
      this.changeShowFooter(false)
    } else {
      this.changeShowFooter(true)
    }
  }
}
